import { getCompanyId, setCompanyId } from "@lhd/utility";
import { useEffect } from "react";

export function useAutoCompanyParam() {
  useEffect(() => {
    const companyIdAtFirstTime = getCompanyId();
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (state, title, url) {
      const companyId = getCompanyId();
      const newState = {
        ...(window.history.state || {}),
        ...(state || {}),
        companyId,
      };

      return originalPushState.apply(this, [newState, title, url]);
    };

    window.history.replaceState = function (state, title, url) {
      const companyId = getCompanyId();
      const newState = {
        ...(window.history.state || {}),
        ...(state || {}),
        companyId,
      };

      return originalReplaceState.apply(this, [newState, title, url]);
    };

    const handleBackForward = (event: PopStateEvent) => {
      const companyId = event.state?.companyId || companyIdAtFirstTime;
      if (companyId) {
        setCompanyId(companyId);
      }
    };
    window.addEventListener("popstate", handleBackForward);

    return () => {
      window.removeEventListener("popstate", handleBackForward);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);
}
